// Mentees on a phone-calls program should see that a mentor opted out of calls.
// Mentors set this in the admin portal; patients cannot change it.
export const mentorDeclinesCalls = ({ viewerProfileType, phoneFeatureEnabled, profile }) => {
  if (viewerProfileType !== 'Patient') return false;
  if (!phoneFeatureEnabled) return false;
  if (profile?.type !== 'PatientPartner') return false;

  return profile.accepts_calls === false;
};
